'use client';

import { useEffect } from 'react';
import { isCapacitorNative } from '@/lib/capacitor-runtime';
import { bindNativeDeepLinkListeners } from '@/lib/native-deep-links';
import { configureNativeStatusBar } from '@/lib/native-permissions';
import { bindNativeSplashHideOnContentReady } from '@/lib/native-splash';
import { unregisterPwaServiceWorkers } from '@/lib/service-worker';

/** Clears SW/cache in Capacitor APK — complements inline script in app/layout.tsx. */
export function CapacitorNativeBoot() {
  useEffect(() => {
    if (!isCapacitorNative()) return;
    void unregisterPwaServiceWorkers();
    void configureNativeStatusBar();
    const unbindSplash = bindNativeSplashHideOnContentReady();
    let urlOpenListener: { remove: () => Promise<void> } | null = null;
    let cancelled = false;
    void (async () => {
      const listener = await bindNativeDeepLinkListeners();
      if (cancelled) {
        void listener?.remove();
        return;
      }
      urlOpenListener = listener;
    })();
    return () => {
      cancelled = true;
      unbindSplash();
      urlOpenListener?.remove().catch(() => {});
    };
  }, []);

  return null;
}
